(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/grid-base/assets/grid-base.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/grid-base/assets/grid-base.js');
'use strict';

const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  Grid = _svs$ui$ReactGrid.Grid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;

const GridBase = _ref => {
  let children = _ref.children,
    className = _ref.className;
  const classString = className ? " ".concat(className) : '';
  return React.createElement("div", {
    className: "align-center padding-top-2 padding-bottom-2 padding-xs-h-1 line-height-150 ".concat(classString)
  }, React.createElement(Grid, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    xs: 12,
    sm: {
      col: 10
    },
    am: {
      col: 8
    },
    md: {
      col: 6
    },
    lg: {
      col: 6
    }
  }, children))));
};
svs.tb_ui_react.gridbase.GridBase = GridBase;

 })(window);